module.exports = __webpack_public_path__ + "static/media/job_oven.477be5f0.svg";